(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@didi/omega-tracker"));
	else if(typeof define === 'function' && define.amd)
		define(["@didi/omega-tracker"], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("@didi/omega-tracker"));
	else
		root["index"] = factory(root["Omega"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__9613__) {
return 